module.exports = __webpack_public_path__ + "img/normal.30ab6deb.svg";